var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-25 position-fixed",
      class: { "set-margin-top": _vm.getButtonCount() },
      attrs: {
        id: "sum-col",
        role: "complementary",
        "aria-labelledby": "quoteSummary"
      }
    },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.getters.getQuoteSummaryStatus,
                expression: "$store.getters.getQuoteSummaryStatus"
              }
            ],
            staticClass: "w-100 shadow-sm qrp-bg-lightgray  pb-3",
            attrs: { id: "sum-content" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "row no-gutters position-relative quote-summary-row"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 py-2 pl-3 float-left bg-black active text-white smaller-font-content",
                    attrs: { id: "quoteSummary" }
                  },
                  [_c("strong", [_vm._v("Quote Summary")])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-100 py-2 px-3 smaller-font-content" },
                  [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "pl-0 pr-2 font-weight-bold" }, [
                        _vm._v("Quote ID:")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col px-0" }, [
                        _vm._v(_vm._s(_vm.getSessionId))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.quoteData, function(qData, qKey) {
                  return _c("div", { key: qKey, staticClass: "w-100" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 py-1 pl-3 float-left active shadow-sm text-white smaller-font-content bg-black"
                      },
                      [_c("strong", [_vm._v(_vm._s(qData.label))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col px-3 accordPanel" },
                      _vm._l(qData.content, function(rData, rKey) {
                        return _c(
                          "div",
                          {
                            key: rKey,
                            staticClass: "py-1 smaller-font-content"
                          },
                          [
                            _vm._l(rData.fields, function(qteData, qteKey) {
                              return _c(
                                "div",
                                {
                                  key: qteKey,
                                  staticClass: "row mx-0 mb-1 sum-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-xl-4 pl-0 pr-2 font-weight-bold"
                                    },
                                    [_vm._v(_vm._s(qteData.label))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col px-0 sum-data" },
                                    [_vm._v(_vm._s(qteData.field_value))]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            rKey != qData.content.length - 1
                              ? _c("div", { staticClass: "border-bottom" })
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      0
                    )
                  ])
                })
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52891b76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52891b76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/QuoteSummary.vue
// module id = null
// module chunks = 